<template>
  <div>
    <div
      class="estimate-loader"
      v-if="loading"
    >
      <span></span>
    </div>

    <div class="estimate-error" v-if="errorFlag && !loading">
      <p>正常にデータが取得できませんでした。<br>お手数ですが時間をあけて再度アクセスしていただくか、<br class="is-sp">お問い合わせください。</p>
    </div>

    <section
      class="estimate-result"
      v-if="!errorFlag && !loading"
    >
      <h3 class="estimate-result__title">お見積結果</h3>
      <figure class="estimate-result__figure">
        <img :src="bikeDetail.image" alt="">
      </figure>

      <div class="estimate-result__content">
        <div class="estimate-result__header">
          <h4>
            <span v-text="bikeDetail.name" />
            <small v-text="bikeDetail.color" />
          </h4>
          <p>
            <small>車両本体価格 (税込)</small>
            <span class="estimate-result__list-price">
              {{bikeDetail.price_with_tax.toLocaleString()}}円
              <em
                v-for="note in bikeDetail.notes"
                v-show="note.type == 'price'"
                v-html="`<sup>*${note.key}</sup>`"
              />
            </span>
          </p>
        </div>


        <table
          v-if="!errorFlag && !loading"
          class="estimate-pdf__table"
        >
          <thead>
          <tr>
            <th>現金販売価格</th>
            <th>税込価格（円）</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>①製品価格</th>
            <td v-text="`${bikeDetail.price_with_tax.toLocaleString()}円`"/>
          </tr>
          <tr>
            <th>②付属品合計</th>
            <td v-text="`${accessoriesPrice.toLocaleString()}円`"/>
          </tr>
          <tr>
            <th>③小計 <small>①+②</small></th>
            <td class="is-bold" v-text="`${(bikeDetail.price_with_tax + accessoriesPrice).toLocaleString()}円`" />
          </tr>
          <tr>
            <th>④諸費用合計 <small>(自賠責保険、手続代行費用{{(bikeDetail.product_type !== '50' && bikeDetail.product_type !== '125') ? '、重量税' : ''}}G防犯登録{{ etcNote ? '、ETCセットアップ手数料' : '' }}{{(bikeDetail.product_type !== '50' && bikeDetail.product_type !== '125') ? '、ナンバー代' : ''}}{{(bikeDetail.product_type !== '50' && bikeDetail.product_type !== '125') ? '、印紙代' : ''}})</small>
              <br><small>※125cc以下のバイクには「重量税」「印紙代」「ナンバー代」が、又250cc以下のバイクには「印紙代」は含まれておりません。</small>
            </th>
            <td class="is-bold" v-text="`${expensesPrice.toLocaleString()}円`" />
          </tr>
          <tr>
            <th>⑤メンテナンスパック <small v-if="result.maintenance != 0" v-text="bikeDetail.maintenance_pack.course_name"/></th>
            <td class="is-bold" v-text="result.maintenance != 0 ? `${bikeDetail.maintenance_pack.price.toLocaleString()}円` : '0円'" />
          </tr>
          <tr>
            <th class="has-bottom">⑥延長保証 <small v-if="result.extendedWarranty != 99" v-text="`(${bikeDetail.warranty[result.extendedWarranty].year}年)`"/></th>
            <td class="has-bottom is-bold" v-text="`${result.extendedWarranty != 99 ? bikeDetail.warranty[result.extendedWarranty].price.toLocaleString() : 0 }円`" />
          </tr>
          </tbody>
        </table>

        <dl class="estimate-pdf__content-second">
          <dt><span>お支払合計金額</span> <small>③+④+⑤+⑥</small></dt>
          <dd v-text="`${(bikeDetail.price_with_tax + accessoriesPrice + expensesPrice + (result.maintenance != 0 ? bikeDetail.maintenance_pack.price : 0) + (result.extendedWarranty != 99 ? bikeDetail.warranty[result.extendedWarranty].price : 0)).toLocaleString() }円`"/>
        </dl>

        <table v-if="result.loan !== 99" class="estimate-pdf__table">
          <thead>
          <tr>
            <th>据置クレジット詳細 <small>(実質年率4.9％)</small></th>
            <th>税込価格（円）</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>⑦ 頭金計 <small>②＋④＋⑤＋⑥</small></th>
            <td v-text="`${(expensesPrice + (result.maintenance != 0 ? bikeDetail.maintenance_pack.price : 0) + accessoriesPrice + (result.extendedWarranty != 99 ? bikeDetail.warranty[result.extendedWarranty].price : 0)).toLocaleString()}円`"/>
          </tr>
          <tr>
            <th>クレジット支払額</th>
            <td v-text="`${bikeDetail.price_with_tax.toLocaleString()}円`"/>
          </tr>
          <tr>
            <th>支払回数</th>
            <td>{{ loanDetail.count }}回／{{loanDetail.count / 12}}年</td>
          </tr>
          <tr>
            <th>⑧初回支払い額</th>
            <td>{{ loanDetail.first.toLocaleString() }}円</td>
          </tr>
          <tr>
            <th>⑨月々 <small>（{{loanDetail.count - 2}}回）</small></th>
            <td>{{ loanDetail.monthly.toLocaleString() }}円</td>
          </tr>
          <tr>
            <th>⑩最終回お支払金額</th>
            <td>{{ loanDetail.last.toLocaleString() }}円</td>
          </tr>
          <tr>
            <th>(クレジット手数料</th>
            <td>{{ (loanDetail.summary - bikeDetail.price_with_tax).toLocaleString() }}円)</td>
          </tr>
          <tr>
            <th class="has-top">⑪クレジットお支払合計 <small>⑧＋⑨＋⑩</small></th>
            <td class="has-top is-bold">{{ loanDetail.summary.toLocaleString() }}円</td>
          </tr>
          </tbody>
        </table>

        <dl v-if="result.loan !== 99" class="estimate-pdf__content-second">
          <dt><span>総支払金額</span><small>⑦+⑪</small></dt>
          <dd>{{ (loanDetail.summary + expensesPrice + (result.maintenance != 0 ? bikeDetail.maintenance_pack.price : 0) + accessoriesPrice + (result.extendedWarranty != 99 ? bikeDetail.warranty[result.extendedWarranty].price : 0)).toLocaleString() }}円</dd>
        </dl>

        <table
          class="estimate-pdf__table"
          v-if="accessoriesPrice !== 0"
        >
          <thead>
          <tr>
            <th>付属品明細</th>
            <th>税込価格（円）</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="result.etc === 1">
            <th>ETC車載器 <small>（本体と取付工賃のみの金額です。車種によって取付オプション品が別途必要な場合があります）</small></th>
            <td v-text="`${etcPrice.toLocaleString()}円`"/>
          </tr>
          <tr v-if="result.coating.length !== 0 || result.coating_options.length !== 0">
            <th>ガラスコーティング <small v-text="coatingNote" /></th>
            <td v-text="`${(Number(result.coating[0] || 0) + result.coating_options.reduce((sum, coatingPrice) => sum + coatingPrice, 0)).toLocaleString()}円`"/>
          </tr>
          <tr v-if="result.recorder === 1">
            <th>ドライブレコーダー <small>（車種により「延長カメラケーブル」「本体・カメラ取付ステー」が別途必要になる場合がございます）</small></th>
            <td v-text="`${recorderPrice.toLocaleString()}円`"/>
          </tr>
          <tr>
            <th class="has-top">付属品合計</th>
            <td class="has-top is-bold" v-text="`${accessoriesPrice.toLocaleString()}円`"/>
          </tr>
          </tbody>
        </table>

        <estimate-note
          class="estimate-result__note"
          :extended-notes="noteList"
        />
      </div>
    </section>
    
    <div
      v-if="!errorFlag && !loading"
      class="estimate-result__action"
    >
      <p class="estimate-result__action-lead">お見積り下さりありがとうございました。</p>

      <p class="estimate-result__action-buttons">
        <button class="button" type="button" @click="transitionPDF('pdf')">作成した見積もりをPDFで出力</button>
        <button class="button" type="button" @click="transitionPDF('mail')">来店予約</button>
      </p>
    </div>

    <div
      v-if="!errorFlag && !loading"
      class="estimate-result__action"
    >
      <p class="estimate-result__action-lead">お客様のご要望に沿って任意保険、<br class="is-sp">車両保険、盗難補償も取り扱っております。</p>

      <p class="estimate-result__action-buttons">
        <a class="button" href="/service/insurance/">任意保険</a>
        <a class="button" href="/service/bike-insurance/">車両保険</a>
        <a class="button" href="/service/theft-compensation/">盗難補償</a>
      </p>
    </div>

    <estimate-recommend-list
      v-if="!errorFlag && !loading"
      :recommend="bikeDetail.recommend"
    />

  </div>
</template>

<script>
import { defineComponent, ref, computed, watch } from "vue";
import axios from 'axios'
import {Util} from './master.js'
import EstimateRecommendList from './estimate/EstimateRecommendList.vue'
import EstimateNote from './estimate/EstimateNote.vue'

export default defineComponent({
  name: 'EstimateResult',
  components: {
    EstimateRecommendList,
    EstimateNote
  },
  props: {
  },
  setup(props) {
    const
      shopName = ref(''),
      firstList = ref({
        insurance: {name: '自賠責保険', price: 0},
        maintenance: {name: 'メンテナンスパック', price: 0},
        coating: {name: 'ガラスコーティング', price: 0, data: []},
        recorder: {name: 'ドライブレコーダー', price: 0},
        etc: {name: 'ETC車載器', price: 0},
        extendedWarranty: { name: '延長保証', price: 0},
        expenses: {name: '諸費用 <small>(自賠責保険を除く)</small>', price: 0},
        loan: {name: 'お支払回数', value: ''}
      }),
      urlParams = new URLSearchParams(window.location.search),
      productID = ref(urlParams.get('id')),
      loading = ref(true),
      errorFlag = ref(false),
      bikeDetail = ref({}),
      totalPrice = ref(0),
      insuranceArray = ref([]),
      licenseFee = ref([]),
      etcFee = ref(0),
      loanDetail = ref({}),
      overhead = ref(0),
      loanCount = ref(0),
      result = ref({
        bike: {},
        color: 0,
        pref: 0,
        insurance: 0,
        maintenance: 0,
        coating: [],
        coating_options: [],
        recorder: 0,
        etc: 0,
        extendedWarranty: 99,
        loan: 99,
        expenses: 1
      }),
      expensesPrice = ref(0),
      recorderPrice = ref(0),
      etcPrice = ref(0),
      etcNote = ref(false),
      noteList = ref([]),
      accessoriesPrice = ref(0)

    const setTotalPrice = () => {
      let price = 0;

      if (Object.keys(bikeDetail.value).length === 0) {
        return price;
      }

      const { pref, insurance, maintenance, coating, coating_options, recorder, etc, extendedWarranty, loan, bike, expenses } = result.value;

      expensesPrice.value = 0
      expensesPrice.value += insuranceArray.value[insurance]?.price // 自賠責保険
      expensesPrice.value += licenseFee.value[pref].price // ナンバープレート発行手数料
      expensesPrice.value += overhead.value // 固定諸費用 代行費用＋重量税（あれば）＋防犯登録　合算
      //- expensesPrice.value += extendedWarranty !== 99 ? bike.warranty[extendedWarranty].price : 0 // 延長保証

      if (bike.etc.price > 0) {
        expensesPrice.value += etc === 1 ? etcFee.value : 0
        etcNote.value = etc === 1
      } else if (etcFee.value > 0) {
        // 標準装備
        expensesPrice.value += etcFee.value
        etcNote.value = true
      }

      const priceCalculations = [
        {
          key: 'insurance',
          condition: insuranceArray.value[insurance],
          value: insuranceArray.value[insurance]?.price || 0
        },
        {
          key: 'maintenance',
          condition: maintenance === 1,
          value: maintenance === 1 ? bike.maintenance_pack.price : 0
        },
        {
          key: 'coating',
          condition: coating.length > 0 || coating_options.length > 0,
          value:
            coating.length > 0 || coating_options.length > 0 ?
              Number(coating) + coating_options.reduce((sum, coatingPrice) => sum + coatingPrice, 0) : 0
        },
        {
          key: 'recorder',
          condition: recorder === 1,
          value: recorder === 1 ? recorderPrice.value : 0
        },
        {
          key: 'etc',
          condition: etc === 1,
          value: etc === 1 ? etcPrice.value : 0
        },
        {
          key: 'extendedWarranty',
          condition: extendedWarranty !== 99,
          value: extendedWarranty !== 99 ? bike.warranty[extendedWarranty].price : 0
        },
        {
          key: 'expenses',
          condition: expenses === 1,
          value: expenses === 1 ? expensesPrice.value : 0
        },
        {
          key: 'loan',
          condition: loan !== 99,
          value: loan !== 99 ? bike.loan[loan].summary : bike.price_with_tax,
          loanValue: loan !== 99 ? `${bike.loan[loan].count}回(据置率${bike.loan[loan].residual_ratio}％)` : '一括払い'
        }
      ];

      loanCount.value = loan !== 99 ? bike.loan[loan].count : 0

      priceCalculations.forEach(({ key, value, loanValue }) => {
        firstList.value[key].price = value;
        price += value;
        if (key === 'loan') {
          firstList.value.loan.value = loanValue;
        }
      });

      totalPrice.value = price;

      // 付属品計算
      accessoriesPrice.value = 0
      accessoriesPrice.value += etc === 1 ? etcPrice.value : 0 // ETC車載器
      accessoriesPrice.value += recorder === 1 ? recorderPrice.value : 0 // ドライブレコーダー
      accessoriesPrice.value += coating.length > 0 ? Number(coating[0]) : 0 // ガラスコーティング
      accessoriesPrice.value += coating_options.length > 0 ? coating_options.reduce((sum, coatingPrice) => sum + coatingPrice, 0) : 0 // ガラスコーティングオプション
    };

    // メンテナンスパック名
    const maintenanceName = (type) => {
      return type === '5S' ? '(5回車検)' : type === '6T' ? '(6回点検)' : ''
    }

    const displayCheck = (key) => {
      const { maintenance, coating, coating_options, recorder, etc, extendedWarranty, loan } = result.value
      const conditions = {
        insurance: false,
        maintenance: maintenance === 0,
        coating: coating.length === 0 && coating_options.length === 0,
        recorder: recorder === 0,
        etc: etc === 0 || bikeDetail.value.etc.price === 0,
        extendedWarranty: extendedWarranty === 99,
        expenses: false,
        loan: false
      }
      return !conditions[key]
    }

    const getDetailData = () => {
      shopName.value = localStorage.getItem('shopName')
      const response = JSON.parse(localStorage.getItem(`estimateResult-${productID.value}`))
      result.value = response.result
      bikeDetail.value = response.result.bike
      bikeDetail.value.name = response.product_name
      bikeDetail.value.product_type = response.product_type
      insuranceArray.value = response.insurance
      licenseFee.value = response.license_fee
      etcFee.value = response.etc_fee
      overhead.value = response.overhead

      if (result.value.loan != 99) {
        loanDetail.value = bikeDetail.value.loan[result.value.loan]
      }

      recorderPrice.value =
        response.result.recorder === 1 ?
          bikeDetail.value.edr.price + (bikeDetail.value.edr.cost > 0 ? bikeDetail.value.edr.cost : 0) : 0

      etcPrice.value =
        response.result.etc === 1 ?
          bikeDetail.value.etc.price + (bikeDetail.value.etc.price > 0 ? bikeDetail.value.etc.cost : 0) : 0

      bikeDetail.value.notes.forEach((note) => {
        if (note.type == 'price') {
          noteList.value.push(`※${note.key} ${note.note}`)
        }
      })

      return result !== null ? true : false
    }

    const setGtag = () => {
      if (window.gtag) {
        window.gtag('event', 'estimate-result', {
          'shop_name': shopName.value,
          'model_name': bikeDetail.value.name,
          'displacement': bikeDetail.value.product_type,
          'custom_dimension_index1': shopName.value,
          'custom_dimension_index2': bikeDetail.value.name,
          'custom_dimension_index3': bikeDetail.value.product_type
        });
      } else {
        console.warn('gtag is not defined');
      }
    }

    const transitionPDF = async (type) => {
      await localStorage.setItem(`estimatePDF-${productID.value}`, JSON.stringify({
        result: result.value,
        bikeDetail: bikeDetail.value,
        insuranceArray: insuranceArray.value,
        license_fee: licenseFee.value,
        etc_fee: etcFee.value,
        overhead: overhead.value,
        loanDetail: loanDetail.value,
        expenses_price: expensesPrice.value,
        recorder_price: recorderPrice.value,
        etc_price: etcPrice.value,
      }))

      // PDFページへ遷移
      location.href = `../pdf/?id=${urlParams.get('id')}&type=${type}`
    }

    return {
      productID,
      loading,
      errorFlag,
      bikeDetail,
      totalPrice,
      insuranceArray,
      overhead,
      result,
      maintenanceName,
      getDetailData,
      options: Util.ESTIMATE.OPTIONS,
      coatingLabels: Util.ESTIMATE.COATING,
      firstList,
      setTotalPrice,
      loanCount,
      loanDetail,
      displayCheck,
      transitionPDF,
      expensesPrice,
      etcPrice,
      etcNote,
      recorderPrice,
      accessoriesPrice,
      noteList,
      setGtag
    }
  },
  async mounted() {
    let result = await this.getDetailData()
    if (result) {
      this.setTotalPrice()
      this.setGtag()
      this.loading = false
    } else {
      this.loading = false
      this.errorFlag = true
    }
  },
  methods: {
  }
})
</script>
